import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

const styles = {
  cell: {
    border: "1px solid #000",
    padding: "4px",
    textAlign: "center",
    verticalAlign: "middle",
  },
};

function RADPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Results and Discussions</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              <strong>Ecosystem services provided by microalgae</strong>
            </p>
            <p>
              Microalgae are photosynthetic microorganisms sequestering carbon
              during photosynthesis in the presence of solar energy, converting
              to carbohydrates and oxygen (Asulabha et al. 2018, 2022).
              Microalgae biomass composed of carbohydrates, lipids, and proteins
              has been widely used in industries to produce fuel (biodiesel,
              bioethanol, methane, biobutanol, and biogas), feed (spirulina, and
              chlorella powder), biofertilizers, and medicines (pharmaceuticals
              and nutraceuticals). Select microalgal species are rich in
              proteins and produce proteins of 2.5 to 7.5 tons/ha/yr (Khan et
              al. 2018a). The provisioning services provided by microalgae from
              wetlands accounts to 110467 Rs/ha/yr.
            </p>
            <p>
              <strong>Ecosystem services provided by fish</strong>
            </p>
            <p>
              Fisheries sector provides livelihoods, income, and economically
              nutritious food to the society (Sincy et al. 2018, 2022). Fish
              compose protein, essential fatty acids, and micronutrients (Fe,
              Zn, Ca, and vitamin A) and form an important component of the
              human diet and serve as medicine (table 4) apart from supporting
              livelihoods of fishing communities. Major carps such as{" "}
              <em>Labeo rohita</em>, <em>Catla catla</em>,{" "}
              <em>Cirrhinus mrigala</em>, and the exotic carps{" "}
              <em>Cyprinus carpio</em>, <em>Ctenopharyngodon idella</em>, and{" "}
              <em>Hypothalmichthys molitrix</em> with high economic value
              constitute a vital component of local economy in India (Dasgupta
              and Panigrahi 2014). Eco-tourism integrates both socio-economic
              and cultural activities involving fishing activities has been
              providing recreation and education services that is aiding in the
              decentralized development (Tursi et al. 2015) based on fish
              resources. The provisioning service provided by fish from wetlands
              in Karnataka accounts to 32175 Rs/ha/yr.
            </p>
            <p>
              <strong>Table 4: </strong>Fish species used in the treatment of
              ailments
            </p>
            <table align="center" width="603">
              <tbody>
                <tr>
                  <td style={styles.cell} width="162">
                    <p>
                      <em>Amblypharyngodon mola</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Whole fish</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Premenstrual pain; pox, pain, asthma</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="162">
                    <p>
                      <em>Anabas testudineus</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Whole fish</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Dysmenorrhoea</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="3" width="162">
                    <p>
                      <em>Anguilla bengalensis</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Fats</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Rheumatoid-arthritis</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="138">
                    <p>Whole body</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Piles and meningitis</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="138">
                    <p>Body mucous</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Burns</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="162">
                    <p>
                      <em>Bagarius bagarius</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Fat</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Rheumatism, gout and joint pain</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="2" width="162">
                    <p>
                      <em>Channa punctatus</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Whole fish</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Tuberculosis; diarrhoea</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="138">
                    <p>Bile</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Malaria</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="162">
                    <p>
                      <em>Channa stewartii</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Whole body</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Diabetes, pain, high pressure</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="162">
                    <p>
                      <em>Clarias batrachus</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Whole body</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Body ache, Small pox</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="162">
                    <p>
                      <em>Eutropiichthys vacha</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Flesh</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Tuberculosis, brain health</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="162">
                    <p>
                      <em>Heteropneustes fossilis</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Whole body</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Pain, wound healing; anemia</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="162">
                    <p>
                      <em>Hilsa ilisha</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Body oil</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Arthritis, scurvy</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="162">
                    <p>
                      <em>Labeo pangusia</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Bile</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Stomach ache</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="162">
                    <p>
                      <em>Labeo rohita</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Gall bladder (Bile)</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Gastric ulcer, intestinal cancer</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="162">
                    <p>
                      <em>Mystus bleekeri</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Whole body</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Dysentery</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="162">
                    <p>
                      <em>Notopterus notopterus</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Whole fish</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Delivery pain, abdominal pain</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="162">
                    <p>
                      <em>Osteobrama cotio </em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Whole body</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Ringworm infection</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="2" width="162">
                    <p>
                      <em>Puntius </em>sp.
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Whole body</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Eye problem; blood purifier; common cold</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="138">
                    <p>Head</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Night blindness; memory loss</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="2" width="162">
                    <p>
                      <em>Wallago attu</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Head</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Liver tonic</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="138">
                    <p>Barbels</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Treatment of diarrhoea</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="162">
                    <p>
                      <em>Xenentodon cancila</em>
                    </p>
                  </td>
                  <td style={styles.cell} width="138">
                    <p>Whole fish</p>
                  </td>
                  <td style={styles.cell} width="303">
                    <p>Joint pain, swelling</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} colspan="3" width="603">
                    <p>
                      <strong>Reference:</strong> Gogoi and Bora 2020; Borah and
                      Prasad 2016; Gupta and Dey 2017; Prakash and Prakash 2021
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p>
              Fish supports the livelihoods of fishing communities with regular
              income and employment (table 5). The estimate indicates of US$
              158,368, the revenue from fish products at Sundarbans (Islam and
              Hossain 2017).
            </p>
            <p>
              <strong>Table 5: </strong>Economic value of fishing from wetlands
            </p>
            <table align="center" width="577">
              <tbody>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>
                      <strong>Water body</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>
                      <strong>Area (ha)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>
                      <strong>Value (USD/yr)</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="197">
                    <p>
                      <strong>Reference</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Kuttanad wetlands, India</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>162125</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>82949309</p>
                  </td>
                  <td style={styles.cell} width="197">
                    <p>Rao 2018</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Bhoj wetland, India</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>3229</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>113103.4</p>
                  </td>
                  <td style={styles.cell} width="197">
                    <p>Verma et al. 2001</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Wular lake, India</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>13000</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>686166.7</p>
                  </td>
                  <td style={styles.cell} width="197">
                    <p>Kaul et al. 2016</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Nakivubo Urban wetland, Uganda</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>529</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>3300</p>
                  </td>
                  <td style={styles.cell} rowspan="4" width="197">
                    <p>Schuijt 2002</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Hadejia Nguru wetland, Nigeria</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>350000</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>3465100</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Chilwa wetland, Malawi</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>240000</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>18675500</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Zambezi basin wetland, Southern Africa</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>2982900</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>78620700</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Chilwa wetland, Malawi</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>240000</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>18675478</p>
                  </td>
                  <td style={styles.cell} rowspan="4" width="197">
                    <p>Zuze 2013</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>That Luang wetland, Laos</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>2000</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>1092092</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Muthurajawela wetland, Sri Lanka</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>6000</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>64904</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Mfolozi flood plain, South Africa</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>20886</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>149543.8</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Muthurajawela wetland, Sri Lanka</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>3068</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>64904</p>
                  </td>
                  <td style={styles.cell} rowspan="2" width="197">
                    <p>Schuyt and Brander 2008</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Whangamarino wetland, New Zealand</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>10320</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>10518</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Rachenahalli lake, India</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>42.09</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>7449</p>
                  </td>
                  <td style={styles.cell} width="197">
                    <p>Ramachandra et al. 2005</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Varthur lake, India</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>220</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>51642</p>
                  </td>
                  <td style={styles.cell} width="197">
                    <p>Ramachandra et al. 2011</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Pong Dam wetland, India</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>15500</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>54160</p>
                  </td>
                  <td style={styles.cell} width="197">
                    <p>Prasher et al. 2006</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Ulluru tank, India</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>3.99</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>4384</p>
                  </td>
                  <td style={styles.cell} rowspan="3" width="197">
                    <p>Ramachandra and Sreekantha 2006</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Kaspadi tank, India</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>1.7</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>1047</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="225">
                    <p>Nagara tank, India</p>
                  </td>
                  <td style={styles.cell} width="68">
                    <p>3.58</p>
                  </td>
                  <td style={styles.cell} width="86">
                    <p>2835</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p>
              <strong>Ecosystem services provided by macrophyte</strong>
            </p>
            <p>
              Macrophyte provides food, fodder, medicine, and aid in water
              purification (remediation), carbon sequestration, while providing
              recreation opportunities (Ramachandra et al. 2018). Macrophyte
              serve as food for other aquatic organisms, fodder for livestock,
              medicine for treating animal and human diseases, fiber, green
              manure, industrial raw materials (manufacture of essential oils),
              pesticides, and ornamental plants (Zhang et al. 2014).{" "}
              <em>Alternanthera sessilis</em>, <em>Eleocharis dulcis</em>, and
              tubers of <em>Colocasia esculenta</em> are being used as
              vegetables, while <em>Fimbristylis dichotoma</em>,{" "}
              <em>Cyperus iria</em>, and <em>C. pangorie</em> are used for
              making mats (Rao et al. 2008). Table 6, lists the ecosystem
              services provided by diverse species of macrophyte, and the value
              of the provisioning services provided by macrophyte amounts to
              11291 Rs/ha/yr.
            </p>
            <p>
              <strong>Table 6: </strong>Benefits of macrophyte
            </p>
            <table align="center">
              <tbody>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <strong>Species</strong>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      <strong>Uses</strong>
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Alternanthera philoxeroides</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Consumed as vegetable, animal feed</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Azolla pinnata</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Treats urinary problems</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Bacopa monnieri</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Cures fever</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Ceratophyllum demersum</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      Reduce pain from insect/scorpion bites; fruit for domestic
                      ducks
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Cyperus </em>sp.
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Source of fiber, fuel, making mats and food</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Eichhornia crassipes</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Used as fertilizer</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Hydrilla verticillata</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Used as fish food, aquarium plant and fertilizer.</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Ipomoea aquatica</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Used as vegetable, and animal feed</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Ludwigia perennis</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Reduces fever</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Nymphaea rubra</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>
                      Flowers are used for religious purposes, an ornamental
                      plant
                    </p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Nymphoides indica</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Reduce fever</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Polygonum barbatum</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Medicinal value</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Salvinia cucullata</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Used as fodder</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Spirodela polyrrhiza</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Used as organic manures, fodder, phytoremediation</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Trapanatans var. bispinosa</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Edible fruit, treats diarrhoea and dyspepsia.</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Vallisneria spiralis</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Used as fish food, ornamental purpose</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell}>
                    <p>
                      <em>Wolffia globosa</em>
                    </p>
                  </td>
                  <td style={styles.cell}>
                    <p>Leaves used as vegetable</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} colSpan={2}>
                    <p>
                      <strong>Reference:</strong> Kiran et al. 2007; Taran and
                      Deb 2020; Nandan and Singh 2004; Misra et al. 2012; Sarma
                      and Saikia 2010; Chai et al. 2015; Khan et al. 2018b
                    </p>
                  </td>
                </tr>
              </tbody>
            </table>
            <p>
              <strong>&nbsp;</strong>
            </p>
            <p>
              <strong>
                Ecosystem service value from wetlands in Karnataka
              </strong>
            </p>
            <p>
              The benefits provided by wetlands of Karnataka can range from
              tangible products (such as food, fodder, fuelwood, medicine, and
              water) to intangible products (such as habitat, climate
              regulation, flood control, erosion control, water and air quality
              regulation, recreation, and aesthetics). The spatial analyses of
              wetlands in Karnataka using remote sensing data, presented in
              figure 6, highlight that about 61% of wetlands had an area of
              &lt;2.5 ha, 36% of wetlands had an area of 2.5 &ndash; 50 ha, and
              3% of wetlands had an area of &gt;50 ha.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/esk6.jpg" alt="" />
            </p>

            <p style={{ textAlign: "center" }}>
              <strong>Figure 6: </strong>Classification of wetlands of Karnataka
              based on size
            </p>
            <p>
              The provisioning, regulating, and cultural services provided by
              wetlands in Karnataka constitute about 18%, 69%, and 13%,
              respectively, of the total ecosystem supply value (figure 7).
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/esk7.jpg" alt="" />
            </p>

            <p style={{ textAlign: "center" }}>
              <strong>Figure 7: </strong>Contribution of ecosystem service
              provided by wetlands of Karnataka
            </p>
            <p>
              The review of ecosystem services across wetlands reveals that the
              provisioning services of the Ga-Mampa wetland are about 90,000
              $/yr (Adekola et al. 2008). Similarly, Satajan wetland and bird
              sanctuary in Assam provided provisioning services (wild edible
              plants, fodder, firewood, fish, fresh water, and wild medicinal
              plants) of Rs 52,65,600 per year, or $78,591 per year (Kakoti et
              al. 2019). Kalyanthakur para lake provides aquatic plants, fishes,
              molluscs, crabs, domestic uses, collection of timber, and
              fuelwood, worth 26263.65 US$/yr, while cultural services amounted
              to 2605.68 US$/yr (Taran et al. 2016). The average provisioning
              services of wetlands considering material collection, fishing,
              crop production, hunting, and logging are about 11,508
              $/household/yr (Adekola et al. 2015). Figure 8 depicts
              district-wise provisioning, and regulating services provided by
              wetlands in Karnataka, which amount to 49.70 and 196.89 billion
              Rs/yr respectively.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/esk8.jpg" alt="" />
            </p>

            <p style={{ textAlign: "center" }}>
              <strong>Figure 8: </strong>a) Provisioning service and b)
              Regulating service of wetlands of Karnataka
            </p>
            <p>
              Recreational services of wetlands include swimming, boating,
              jogging, gardening, amusement parks, and as picnic spots for
              scenic beauty. The lakes in Karnataka have cultural significance,
              for example, Lalbagh lake inside the Lalbagh Botanical Gardens
              supports a variety of flora and fauna and attracts nature lovers,
              bird watchers, and tourists. Nagavara lake in Bengaluru has the
              water-front leisure park, Gardens, adjacent to it. The amusement
              park for children, and musical fountains, are popular among the
              visitors. Thonnur lake in Mysuru is an attractive spot for bird
              watching, boating, and swimming. Researchers are attracted to
              Karanji lake in Mysuru as it has the largest walk-through aviary
              in India and a butterfly park. The Regional Museum of Natural
              History on the banks of Karanji lake provides information on the
              natural environment of South India and nature conservation. Pampa
              Sarovar is a sacred lake in Koppal district, Karnataka. A special
              pooja is conducted in the Honnamana kere (Honnama lake) in Kodagu
              during the Gowri festival. People offer bagina (puja items along
              with flowers and bangles placed in a bamboo basket) to the lake
              and pray for good rain. In Karnataka, during Ganesh Chaturthi,
              Ganesh idols are immersed in <em>Kalyani</em> near the lakes.
              During festivals such as Durga puja, Jagadhatri puja, Lakshmi
              puja, and Ganesh Chaturthi, visitors perform puja in lakes
              (Bhattacharya et al. 2014; Bengani et al. 2020).
            </p>
            <p>
              The cultural services provided by wetlands in Karnataka amount to
              37.93 billion Rs/yr and the district-wise share is presented in
              figure 9. The annual economic value of the cultural service of the
              Pateira de Fermentelos wetland is estimated at 3087 &euro;/ha/yr
              (Roebeling et al. 2016). About 90% of people are willing to pay
              (WTP) for recreation in the Kanibrazan wetland, with an average
              estimate of 38217 Rials/person (Zarandi et al. 2019). The cultural
              services of wetlands are evident from the revenue of US$ 144832
              from the Sundarbans from tourism with 96949 native and 3868
              foreign tourists (Islam and Hossain 2017).
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/esk9.jpg" alt="" />
            </p>

            <p style={{ textAlign: "center" }}>
              <strong>Figure 9: </strong>Cultural service of wetlands of
              Karnataka
            </p>
            <p>
              Figure 10 illustrates the ecosystem services provided by wetlands,
              district-wise in Karnataka, and the analyses reveal that the
              Tumakuru district with the larger spatial extent of wetlands,
              contributes significantly (47,142 million Rs/year) through
              ecosystem services, followed by Kolar, Chitradurga, Hassan,
              Chikkaballapura, Mandya, and Shivamogga. The value of
              provisioning, regulating, and cultural services provided by
              wetlands in Tumakuru district is 8214, 32641, and 6287 million
              Rs/yr respectively. Udupi district had the lowest values of 40,
              157, and 30 million rupees per year in provisioning, regulating,
              and cultural services, respectively.
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/esk10.jpg" alt="" />
            </p>

            <p style={{ textAlign: "center" }}>
              <strong>Figure 10: </strong>District wise ecosystem service value
              of wetlands of Karnataka
            </p>
            <p>
              <strong>
                Total ecosystem supply value (TESV) and NPV of the wetlands in
                Karnataka
              </strong>
            </p>
            <p>
              Total ecosystem supply value is the summation of provisioning,
              regulating, and cultural services. TESV depends on the spatial
              extent and condition of the ecosystem. The TESV of Karnataka
              wetlands presented district-wise in figure 11a reveals that
              Tumakuru district tops among all districts with 47.14 billion
              Rs/yr of the total 284.52 billion Rs/yr from wetlands in
              Karnataka. The average total economic value for food, water
              provisioning, and wastewater treatment in the Boeng Cheung Aek
              wetland is 30.12 million USD/yr, ranging from 15.71- 48.96 million
              USD/yr (Ro et al. 2020).
            </p>
            <p>
              NPV computed based on the annual flow of TESV shows that the worth
              of ecosystem assets of wetlands in Karnataka amounts to 7321
              billion rupees. Figure 11b depicts district-wise variability of
              NPV, with the highest NPV of 1213 billion rupees being in the
              Tumakuru district. NPV ranged between 450 - 650 billion rupees in
              districts like Chitradurga, Chikkaballapura, Hassan, and Kolar,
              whereas it ranged between 250 - 450 billion rupees in Davanagere,
              Haveri, and Shivamogga. Similar studies done across the globe
              indicate the net present value of revenue (benefits) earned during
              the last ten years from Sukhna lake in Chandigarh was estimated at
              Rs. 451 million (Chaudhry et al. 2013). In the case of Koshi Tappu
              Wildlife Reserve, the total net benefit value from wetland fodder
              was estimated at USD 4251,919 (Sharma et al. 2015).
            </p>
            <p style={{ textAlign: "center" }}>
              <img src="images/esk11.jpg" alt="" />
            </p>

            <p style={{ textAlign: "center" }}>
              <strong>Figure 11: </strong>a) TESV and b) NPV of wetlands of
              Karnataka
            </p>
            <p>
              Wetlands are fundamental to the economic, social, and cultural
              wellbeing of the population in India. Table 7 lists provisioning,
              regulating, cultural services, TESV, and NPV of wetlands in
              Karnataka. Wetlands cover an area of 281300 hectares in Karnataka
              and provide provisioning services worth 1.8 lakh Rs/ha/yr,
              regulating services worth 7 lakh Rs/ha/yr, and cultural services
              worth 1.3 lakh Rs/ha/yr. The total ecosystem supply value (TESV)
              of wetlands in Karnataka amounts to 285 billion Rs/yr (10.1 lakh
              Rs/ha/yr) and the NPV of wetland assets is about 7321 billion
              rupees (table 7).
            </p>
            <p>
              <strong>Table 7: </strong>Total ecosystem value of Karnataka
              wetlands
            </p>
            <table align="center" width="627">
              <tbody>
                <tr>
                  <td style={styles.cell} width="151">
                    <p>
                      <strong>Services</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="302">
                    <p>
                      <strong>Details</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="174">
                    &nbsp;
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="151">
                    &nbsp;
                  </td>
                  <td style={styles.cell} width="302">
                    <p>Wetland: Total area (ha) based on grid</p>
                  </td>
                  <td style={styles.cell} width="174">
                    <p>281299.5</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="3" width="151">
                    <p>
                      <strong>Provisioning Service</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="302">
                    <p>Total Rs/yr (in Billion Rupees)</p>
                  </td>
                  <td style={styles.cell} width="174">
                    <p>49.70</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="302">
                    <p>Production Rs/ha/yr (in Lakhs)</p>
                  </td>
                  <td style={styles.cell} width="174">
                    <p>1.8</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="302">
                    <p>% distribution</p>
                  </td>
                  <td style={styles.cell} width="174">
                    <p>18</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="3" width="151">
                    <p>
                      <strong>Regulating Service</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="302">
                    <p>Total Rs/yr (in Billion Rupees)</p>
                  </td>
                  <td style={styles.cell} width="174">
                    <p>196.89</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="302">
                    <p>Production Rs/ha/yr (in Lakhs)</p>
                  </td>
                  <td style={styles.cell} width="174">
                    <p>7</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="302">
                    <p>% distribution</p>
                  </td>
                  <td style={styles.cell} width="174">
                    <p>69</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="3" width="151">
                    <p>
                      <strong>Cultural Service</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="302">
                    <p>Total Rs/yr (in Billion Rupees)</p>
                  </td>
                  <td style={styles.cell} width="174">
                    <p>37.93</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="302">
                    <p>Production Rs/ha/yr (in Lakhs)</p>
                  </td>
                  <td style={styles.cell} width="174">
                    <p>1.3</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="302">
                    <p>% distribution</p>
                  </td>
                  <td style={styles.cell} width="174">
                    <p>13</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} rowspan="2" width="151">
                    <p>
                      <strong>TESV</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="302">
                    <p>Total Rs/yr (in Billion Rupees)</p>
                  </td>
                  <td style={styles.cell} width="174">
                    <p>284.52</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="302">
                    <p>Production Rs/ha/yr (in Lakhs)</p>
                  </td>
                  <td style={styles.cell} width="174">
                    <p>10.1</p>
                  </td>
                </tr>
                <tr>
                  <td style={styles.cell} width="151">
                    <p>
                      <strong>NPV</strong>
                    </p>
                  </td>
                  <td style={styles.cell} width="302">
                    <p>NPV in Billion Rupees</p>
                  </td>
                  <td style={styles.cell} width="174">
                    <p>7320.6</p>
                  </td>
                </tr>
              </tbody>
            </table>
            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default RADPage;
